module.exports = __webpack_public_path__ + "img/section5Step2.3a8679ff.png";